import { createContext, useContext } from "react";

const IsBundledQuoteContext = createContext<boolean>(false);
export const IsBundledQuoteContextProvider = IsBundledQuoteContext.Provider;
export const useIsBundledQuote = () => useContext(IsBundledQuoteContext);
